var map = {
	"./finity/lottie/account_manage.json": 1300,
	"./finity/lottie/calendar.json": 1044,
	"./finity/lottie/calender_complete.json": 1301,
	"./finity/lottie/calender_error.json": 1302,
	"./finity/lottie/calender_pause.json": 1303,
	"./finity/lottie/calender_reinvest.json": 1304,
	"./finity/lottie/coin1.json": 1305,
	"./finity/lottie/coin2.json": 1306,
	"./finity/lottie/coin3.json": 1307,
	"./finity/lottie/debt.json": 1308,
	"./finity/lottie/equity.json": 1309,
	"./finity/lottie/hybrid.json": 1310,
	"./finity/lottie/insights.json": 1311,
	"./finity/lottie/kyc_complete.json": 1045,
	"./finity/lottie/no_mf_order.json": 1046,
	"./finity/lottie/one_kyc.json": 1312,
	"./finity/lottie/order_place.json": 1313,
	"./finity/lottie/signfier.json": 1047,
	"./finity/lottie/success_animation.json": 1048,
	"./finity/lottie/tick.json": 1049,
	"./finity/lottie/wallet.json": 1050,
	"./finity/lottie/withdrawal.json": 1314,
	"./finity/lottie/zero_investment.json": 1315,
	"./fisdom/lottie/account_manage.json": 1500,
	"./fisdom/lottie/calendar.json": 1069,
	"./fisdom/lottie/calender_complete.json": 1501,
	"./fisdom/lottie/calender_error.json": 1502,
	"./fisdom/lottie/calender_paused.json": 1503,
	"./fisdom/lottie/calender_reinvest.json": 1504,
	"./fisdom/lottie/coin1.json": 1505,
	"./fisdom/lottie/coin2.json": 1506,
	"./fisdom/lottie/coin3.json": 1507,
	"./fisdom/lottie/debt.json": 1508,
	"./fisdom/lottie/equity.json": 1509,
	"./fisdom/lottie/hybrid.json": 1510,
	"./fisdom/lottie/insights.json": 1511,
	"./fisdom/lottie/kyc_complete.json": 1070,
	"./fisdom/lottie/no_mf_order.json": 1071,
	"./fisdom/lottie/one_kyc.json": 1512,
	"./fisdom/lottie/order_place.json": 1513,
	"./fisdom/lottie/signfier.json": 1072,
	"./fisdom/lottie/success_animation.json": 1073,
	"./fisdom/lottie/tick.json": 1074,
	"./fisdom/lottie/wallet.json": 1075,
	"./fisdom/lottie/withdrawal.json": 1514,
	"./fisdom/lottie/zero_investment.json": 1515,
	"./lottie/calander_complete.json": 1111,
	"./lottie/loader.json": 1112,
	"./lottie/negative.json": 1113,
	"./lottie/payment_cancel.json": 1114,
	"./lottie/positive.json": 1115,
	"./lottie/success.json": 1116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5072;